import { Box, IconButton, useMediaQuery, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Check, X } from 'lucide-react';
import React, { useState } from 'react';

import SegmentRateBar from '../SegmentRateBar/SegmentRateBar';

interface SuggestedSkillRateBarProps {
    onAdd: (level: number) => void;
    onHide: () => void;
    disabled?: boolean;
}

export default function SuggestedSkillRateBar({ onAdd, onHide, disabled = false }: SuggestedSkillRateBarProps) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [selectedLevel, setSelectedLevel] = useState(0);

    const handleAdd = () => {
        if (selectedLevel > 0) {
            onAdd(selectedLevel);
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: { xs: 1, sm: 1.5 },
                width: '100%',
            }}
        >
            <Box sx={{ flex: 1 }}>
                <SegmentRateBar level={selectedLevel} onChange={setSelectedLevel} disabled={disabled} />
            </Box>

            <Box sx={{ display: 'flex', gap: 0.5 }}>
                <IconButton
                    size={isMobile ? 'small' : 'medium'}
                    disabled={disabled || selectedLevel === 0}
                    onClick={handleAdd}
                    sx={{
                        bgcolor:
                            selectedLevel > 0
                                ? alpha(theme.palette.success.main, 0.1)
                                : alpha(theme.palette.action.disabled, 0.1),
                        color: selectedLevel > 0 ? theme.palette.success.main : theme.palette.action.disabled,
                        '&:hover': {
                            bgcolor:
                                selectedLevel > 0
                                    ? alpha(theme.palette.success.main, 0.2)
                                    : alpha(theme.palette.action.disabled, 0.1),
                        },
                        '&:disabled': {
                            bgcolor: alpha(theme.palette.action.disabled, 0.1),
                            color: theme.palette.action.disabled,
                        },
                    }}
                >
                    <Check size={isMobile ? 16 : 18} />
                </IconButton>

                <IconButton
                    size={isMobile ? 'small' : 'medium'}
                    disabled={disabled}
                    onClick={onHide}
                    sx={{
                        bgcolor: alpha(theme.palette.error.main, 0.1),
                        color: theme.palette.error.main,
                        '&:hover': {
                            bgcolor: alpha(theme.palette.error.main, 0.2),
                        },
                        '&:disabled': {
                            bgcolor: alpha(theme.palette.action.disabled, 0.1),
                            color: theme.palette.action.disabled,
                        },
                    }}
                >
                    <X size={isMobile ? 16 : 18} />
                </IconButton>
            </Box>
        </Box>
    );
}
